<template>
  <div class="header-wrapper layout align-end">
    <div>
      <slot name="left" />
    </div>
    <v-spacer />
    <div class="mr-4 align-center layout">
      <slot class="mr-4" name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderView'
};
</script>

<style scoped>
.header-wrapper {
  height: 100px;
  background-color: white;
}
</style>
